export interface CacheNameType {
  name: string
  exists: boolean
}
export class HandleCacheData {
  name?: string

  constructor(name: string = '', data = null) {
    this.name = name
    if (!window.cacheNames) {
      const prevNames = localStorage.getItem('cache-names')
      window.cacheNames = [...(prevNames ? JSON.parse(prevNames) : [])]
    }
  }
  set(data: any) {
    const expireDate = new Date()
    expireDate.setDate(expireDate.getDate() + 3)
    if (this.name)
      localStorage.setItem(
        this.name,
        JSON.stringify({
          data,
          expireDate: expireDate.toLocaleDateString(),
        }),
      )
    this.setName()
  }

  get() {
    const cacheName = window.cacheNames?.find(item => item.name === this.name)
    if (cacheName && !cacheName?.exists) return null
    let localItems: any = this.name && localStorage.getItem(this.name)
    if (localItems) {
      localItems = JSON.parse(localItems)
      if (new Date(localItems.expireDate) > new Date()) {
        this.setName()
        return localItems.data
      } else {
        this.setName(false)
        this.name && localStorage.removeItem(this.name)
        return null
      }
    }
    this.setName(false)
  }

  removeAllCache() {
    if (window.cacheNames) {
      for (let i = 0; i < window.cacheNames.length; i++) {
        const item = window.cacheNames[i]
        localStorage.removeItem(item.name)
      }
      localStorage.removeItem('cache-names')
    }
  }

  get getCacheNames(): CacheNameType[] {
    return window.cacheNames
  }

  private setName(exists: boolean = true) {
    const localCache = [...window.cacheNames]
    const cacheName = localCache.find(item => item.name === this.name)
    if (cacheName) {
      cacheName.exists = exists as boolean
      window.cacheNames = localCache
    } else {
      const cacheNames = [
        ...window.cacheNames,
        { name: this.name as string, exists: exists },
      ]
      localStorage.setItem('cache-names', JSON.stringify(cacheNames))
      window.cacheNames = cacheNames
    }
  }
}
